export class Button {
	constructor(component_key) {
		this.id = component_key;
		this.component = yalwa.v.components[component_key];
		this.$root = jQuery(`.js-${this.id}`);
		// Scope all element lookups within $root using standardized JS hook classes
		this.$icon = this.$root.find(`.js-${this.component.component_type}_element_icon`);
		this.$label = this.$root.find(`.js-${this.component.component_type}_element_label`);
	}
	init() {

	}
}